import { MessageActions } from '../types';

interface IPayload {
  action: string;
  [key: string]: unknown;
}

export interface IBroadcastChannelHandlers {
  handleCollectFormFields?: (data) => void,
  handlePermissions?: (data) => void,
  handleChangePotentialCardType?: (data) => void,
}

class BroadcastChannelService {
  private broadcastChannel;

  init = (handlers: IBroadcastChannelHandlers, sessionId: string, libInitializeId: string) => {
    this.broadcastChannel = new BroadcastChannel(`session=${sessionId}&libInitializeId=${libInitializeId}`);
    this.handleBroadcastChannel(handlers);
  };

  private handleBroadcastChannel = ({
    handleCollectFormFields,
    handlePermissions,
    handleChangePotentialCardType,
  }: IBroadcastChannelHandlers) => {
    this.broadcastChannel.addEventListener('message', (event) => {
      const { data } = event;

      if (!data || !data.action) return;

      if (data.action === MessageActions.FIELD_VALUE) {
        handleCollectFormFields && handleCollectFormFields(data);
      } else if (data.action === MessageActions.PERMISSIONS) {
        handlePermissions && handlePermissions(data);
      } else if (data.action === MessageActions.CARD_TYPE_CHANGE) {
        handleChangePotentialCardType && handleChangePotentialCardType(data);
      }
    });
  };

  broadcastChannelServicePost = (payload: IPayload) => {
    this.broadcastChannel.postMessage(payload);
  };

  closeBroadcastChannel = () => {
    this.broadcastChannel.close();
  };
}

export const bCService = new BroadcastChannelService();
